import { render, staticRenderFns } from "./HeaderPriceWidget.vue?vue&type=template&id=da746e56&scoped=true&lang=html&"
import script from "./HeaderPriceWidget.vue?vue&type=script&lang=js&"
export * from "./HeaderPriceWidget.vue?vue&type=script&lang=js&"
import style0 from "./HeaderPriceWidget.vue?vue&type=style&index=0&id=da746e56&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da746e56",
  null
  
)

export default component.exports